export const SET_RELAY_VARIABLES = 'SET_RELAY_VARIABLES';
export function setRelayVariables(payload) {
    return { type: SET_RELAY_VARIABLES, variables: payload };
}

export const UPDATE_RELAY_VARIABLES = 'UPDATE_RELAY_VARIABLES';
export function updateRelayVariables(payload) {
    return { type: UPDATE_RELAY_VARIABLES, variables: payload };
}
